import type { MidiLogEntry } from '@/lib/midi'

/** Enough to follow a bank transfer and the replies around it without the list growing unbounded. */
const logLimit = 50

export class MidiLogStore {
  private listeners = new Set<() => void>()
  private snapshot: MidiLogEntry[]
  private appended = false

  constructor(initialEntries: MidiLogEntry[]) {
    this.snapshot = initialEntries.slice(0, logLimit)
  }

  readonly getSnapshot = () => this.snapshot

  /** Whether anything has been logged since the store was created with its start-up entries. */
  readonly hasActivity = () => this.appended

  readonly subscribe = (listener: () => void) => {
    this.listeners.add(listener)
    return () => {
      this.listeners.delete(listener)
    }
  }

  append(entry: MidiLogEntry) {
    this.appended = true
    this.snapshot = [entry, ...this.snapshot].slice(0, logLimit)
    this.listeners.forEach((listener) => listener())
  }
}
